import atomicHandShakeMp4 from "../../assets/images/atomic-handshake.mp4";
import atomicHandShakeWebm from "../../assets/images/atomic-handshake.webm";
import atomicHandShakeImg from "../../assets/images/atomic-handshake.webp";
import atomicBlastMp4 from "../../assets/images/atomic-blast.mp4";
import atomicBlastWebm from "../../assets/images/atomic-blast.webm";
import atomicBlastSlowMp4 from "../../assets/images/atomic-blast-2.mp4";
import atomicBlastSlowWebm from "../../assets/images/atomic-blast-2.webm";
import { useEffect, useState } from "react";
import { AutoPlayVideo } from "../video/AutoPlayVideo";

export const EntryTransition = () => {
  const [showAtomicBlast, setShowAtomicBlast] = useState<boolean>(true);
  const [showHandShakeImg, setShowHandShakeImg] = useState<boolean>(false);
  const [showHandShakeGif, setShowHandShakeGif] = useState<boolean>(true);
  const [showAtomicBlastSlow, setShowAtomicBlastSlow] = useState<boolean>(true);

  useEffect(() => {
    if (showAtomicBlast) {
      setTimeout(() => {
        setShowHandShakeImg(true);
      }, 200);
      setTimeout(() => {
        setShowAtomicBlast(false);
        setShowHandShakeImg(false);
        setShowAtomicBlastSlow(false);
        setShowHandShakeGif(false);
      }, 1900);
    }
  }, [showAtomicBlast]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {showAtomicBlast ? (
        <AutoPlayVideo
          mp4Src={atomicBlastMp4}
          webmSrc={atomicBlastWebm}
          alt="Kaboom!"
          style={{
            height: "20vh",
            objectFit: "contain",
            position: "fixed",
            top: "45vh",
            opacity: 0.8,
            WebkitMask: "radial-gradient(circle, black 0%, transparent 40%)",
            mask: "radial-gradient(circle, black 0%, transparent 40%)",
          }}
          className="image-shake"
        />
      ) : undefined}
      {showHandShakeImg ? (
        <img
          src={atomicHandShakeImg}
          alt="fuck-yeaaaah"
          style={{
            position: "fixed",
            top: 0,
            left: "-10vw",
            width: "130vw",
            opacity: 0.15,
          }}
          className="image-shake"
        />
      ) : undefined}
      {showAtomicBlastSlow ? (
        <AutoPlayVideo
          mp4Src={atomicBlastSlowMp4}
          webmSrc={atomicBlastSlowWebm}
          alt="Kaboooooom!"
          style={{
            top: "0",
            left: "-30vh",
            width: "140vw",
            position: "fixed",
            opacity: 0.1,
          }}
        />
      ) : undefined}
      {showHandShakeGif ? (
        <AutoPlayVideo
          mp4Src={atomicHandShakeMp4}
          webmSrc={atomicHandShakeWebm}
          alt="fuck-yeah"
          style={{
            top: "-10vh",
            left: 0,
            width: "180vw",
            position: "fixed",
            opacity: 0.2,
          }}
        />
      ) : undefined}
    </div>
  );
};
